module.exports = __webpack_public_path__ + "assets/img/yingte.bc1f7aa8.png";